import { Pipe, PipeTransform } from '@angular/core';
import { CompensationCategoriesService } from '@bo-client/activation-management/shared/compensation-categories/compensation-categories.service';

@Pipe({
  name: 'compCatPowerRangePipe'
})
export class CompCatPowerRangePipe implements PipeTransform {
  constructor(public compensationCategoriesService: CompensationCategoriesService) {}

  transform(value: any): any {
    const idx = this.compensationCategoriesService.compensationCategoryPowerRangeType.findIndex(
      (ele) => ele.value == value
    );
    let textFound = 'not found';
    if (idx != -1) {
      textFound = this.compensationCategoriesService.compensationCategoryPowerRangeType[idx].displayName;
    }
    return textFound;
  }
}
